import { useEffect, useState } from 'react';
import { PositionDto } from '../DocumentT';
import { PositionS } from '../PositionS';

// eslint-disable-next-line import/prefer-default-export
export const usePositionProducts = () => {
  const [products, setProducts] = useState<PositionDto[]>([]);

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = () => PositionS.fetchProducts().then(setProducts);

  return { products, refresh: loadProducts };
};
